import gql from 'graphql-tag';

export default gql`
query queryAppReviews (
  $uuid: String!
) {
  queryAppReviews(uuid: $uuid) {
    items {
      uuids

      user
      image
      name

      ratingApproved
      reviewApproved
    }
  }
}
`;
